export const CURRENT_USER_QUERY = `
{
  me {
    id
    name
    email
    avatar
    role
    impersonating
    generalManager
    enableReports
    termsAcceptedAt
    account {
      id
      name
      orderApproveFlow
      truckInventoryFeature
      binInventoryFeature
      ordersEnabled
      erpCatalogs
      erpOrders
    }
  }
}
`
